module.exports = __webpack_public_path__ + "45e4a6fd86327ea7e14fc7453ea93ba7.MP3";